import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@fetmode/i18n';
import { primaryStreamHealthIssue } from './health.js';
export function StreamHealthBanner({ health, paid, side }) {
    const issue = primaryStreamHealthIssue(health.issues) ?? primaryStreamHealthIssue(health.remoteIssues);
    if (!issue || health.severity === 'idle') {
        return null;
    }
    const paidHint = paid && side === 'fan'
        ? t('common.streamHealth.paidFan')
        : paid && side === 'model'
            ? t('common.streamHealth.paidModel')
            : null;
    const fansHint = side === 'model' && health.remoteIssueCount > 0
        ? t('common.streamHealth.fansAffected').replace('{{count}}', String(health.remoteIssueCount))
        : null;
    return (_jsxs("div", { className: `fm-stream-health fm-stream-health--${health.severity}${paid ? ' fm-stream-health--paid' : ''}`, role: health.severity === 'bad' ? 'alert' : 'status', children: [_jsx("p", { className: "fm-stream-health__title", children: t(`common.streamHealth.${issue}`) }), fansHint ? _jsx("p", { className: "fm-stream-health__hint", children: fansHint }) : null, paidHint ? _jsx("p", { className: "fm-stream-health__hint", children: paidHint }) : null] }));
}
//# sourceMappingURL=StreamHealthBanner.js.map